import { Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import FullPageLoader from '@/shared/components/FullPageLoader';
import NavigateWithRedirect from '@/shared/components/NavigateWithRedirect';
import { ExpandYourNetwork } from './components/ExpandYourNetwork';
import { RequestNewCustomers } from './components/RequestNewCustomers';
import Root from './FindYourCustomer';

export const findYourCustomersBasename = 'find-your-customers';

const findYourCustomersRouteConfig: RouteObject = {
  path: findYourCustomersBasename,
  element: (
    <Suspense fallback={<FullPageLoader />}>
      <Root />
    </Suspense>
  ),
  children: [
    {
      index: true,
      element: <NavigateWithRedirect to="expand-your-network" />,
    },
    {
      path: 'expand-your-network',
      element: <ExpandYourNetwork />,
    },
    {
      path: 'request-new-customers',
      element: <RequestNewCustomers />,
    },
    { path: '*', element: <NavigateWithRedirect to="expand-your-network" /> },
  ],
};

export default findYourCustomersRouteConfig;
